import { EVisibility } from '@/types/types';

import { TBroadcastScheduleProgramBodySegmentToolkitLogotiposForm } from '../types';

const LOGO_FORM_DEFAULT_VALUES: TBroadcastScheduleProgramBodySegmentToolkitLogotiposForm = {
  logo_id: '',
  entity_label: '',
  entity_score: 100,
  start_datetime: null,
  end_datetime: null,
  parameters: {
    start_frame: undefined,
    end_frame: undefined,
    bbox: null,
    landmarks: [],
    visibility: EVisibility.MEDIA,
    support_id: undefined,
  },
  segment_logo_id: '',
  review_state: 1,
};

const DEFAULT_LOGO_SORT_KEY = 'entity_label';
const DEFAULT_LOGO_SORT_ORDER = 'asc';

export { LOGO_FORM_DEFAULT_VALUES, DEFAULT_LOGO_SORT_KEY, DEFAULT_LOGO_SORT_ORDER };
